import React from 'react';

import { Navigation } from '@components/Navigation';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { MetaHelper } from '@utils/pages';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    flex: 1,
    [theme.breakpoints.up('lg')]: {
      padding: '1rem 2rem',
    },
    backgroundColor: theme.palette.background.paper,
  },
  inner: {
    ...common.flexColumn,
    maxWidth: '1600px',
    padding: '1rem 1rem',
    margin: '0 auto',
  },
  contents: {
    ...common.flexInline,
    [theme.breakpoints.down('sm')]: {
      ...common.flexColumn,
    },
  },
  innerContent: {
    flex: 1,
  },
}));

export const AccountManagerContainer: React.FC<React.PropsWithChildren<{}>> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { children } = props;

  const pages = MetaHelper.shared.withPrefix('/settings/AccountManager');

  return (
    <div className={classes.container}>
      <div className={classes.inner}>
        <div className={classes.contents}>
          <Navigation
            baseUrl="/settings/AccountManager"
            routes={pages.map((m) => ({
              name: m.name,
              label: m.title!,
              icon: <img src={m.icon} alt={m.title} height={30} width={30} />,
            }))}
          />

          <div className={classes.innerContent}>{children}</div>
        </div>
      </div>
    </div>
  );
};
